var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_SET_STORES = 'api/store';
const GET_SET_STORES_V2 = 'api/v2/stores';
const GET_SET_STORE_IMAGE = 'api/store-image';
const GET_PICKUP_SCHEDULE_CUSTOMERS_APP = (storeId) => `${GET_STORES_WASHDAY_APP}/${storeId}/pickup-schedule`;
const REQUEST_PARAMS = {
    token: 'LOGGED_USER_TOKEN',
};
const GET_STORES_WASHDAY_APP = 'api/v2/washdayapp/store';
export const getStores = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            REQUEST_PARAMS.token = this.apiToken;
            let queryParams = '';
            if (params.isActive) {
                queryParams += `isActive=${params.isActive}`;
            }
            const response = yield this.axiosInstance.get(`${GET_SET_STORES}?${queryParams}`, { params: Object.assign({}, REQUEST_PARAMS) });
            return ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.stores) || [];
        }
        catch (error) {
            console.error('Error fetching getStores:', error);
            throw error;
        }
    });
};
export const getStoreReviewLink = function (storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_STORES}/review-link/${storeId}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getStoreReviewLink:', error);
            throw error;
        }
    });
};
export const getStoreById = function (storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            REQUEST_PARAMS.token = this.apiToken;
            const response = yield this.axiosInstance.get(`${GET_SET_STORES}/${storeId}`, { params: Object.assign({}, REQUEST_PARAMS) });
            return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.data) || {};
        }
        catch (error) {
            console.error('Error fetching getStoreById:', error);
            throw error;
        }
    });
};
export const getStoreImages = function (storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_STORE_IMAGE}?store=${storeId}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getStoreImages:', error);
            throw error;
        }
    });
};
export const getStoresByName = function (query) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const config = {};
            const queryParams = generateQueryParamsStr(['q'], query);
            const response = yield this.axiosInstance.get(`${GET_STORES_WASHDAY_APP}?${queryParams}`, config);
            return ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.stores) || [];
        }
        catch (error) {
            console.error('Error fetching getStoresByName:', error);
            throw error;
        }
    });
};
export const getStoresByIdCustomersApp = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_STORES_WASHDAY_APP}/${id}`, config);
            return ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.store) || [];
        }
        catch (error) {
            console.error('Error fetching getStoresByIdCustomersApp:', error);
            throw error;
        }
    });
};
export const getPickupScheduleCustomersApp = function (storeId, query) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr(["date"], query);
            const response = yield this.axiosInstance.get(`${GET_PICKUP_SCHEDULE_CUSTOMERS_APP(storeId)}?${queryParams}`, config);
            return ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.pickupSchedule) || [];
        }
        catch (error) {
            console.error('Error fetching getPickupScheduleCustomersApp:', error);
            throw error;
        }
    });
};
export const getOrderSequence = function (storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_STORES_V2}/${storeId}/settings/order-sequence`, config).then(response => { var _a; return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.data) || {}; });
        }
        catch (error) {
            console.error('Error fetching getOrderSequence:', error);
            throw error;
        }
    });
};
export const getPaymentFees = function (storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_STORES_V2}/${storeId}/payment-fees`, config)
                .then(response => { var _a; return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.data) || {}; });
        }
        catch (error) {
            console.error('Error fetching getPaymentFees:', error);
            throw error;
        }
    });
};
